import { render, staticRenderFns } from "./PromotionBanners.vue?vue&type=template&id=dd32b326&scoped=true&"
import script from "./PromotionBanners.vue?vue&type=script&lang=js&"
export * from "./PromotionBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd32b326",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd32b326')) {
      api.createRecord('dd32b326', component.options)
    } else {
      api.reload('dd32b326', component.options)
    }
    module.hot.accept("./PromotionBanners.vue?vue&type=template&id=dd32b326&scoped=true&", function () {
      api.rerender('dd32b326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Updowngrade/PromotionBanners.vue"
export default component.exports